import type { UserOrganization } from "~~/types/user";

export const useOrganizationStore = defineStore(
  "user-organization",
  () => {
    const organization = ref<UserOrganization | null>(null);

    function setOrganization(newOrganization: UserOrganization) {
      organization.value = newOrganization;
    }

    function reset() {
      organization.value = null;
    }

    const organizationUrl = computed(() =>
      organization.value ? organization.value.organizationUrl : null,
    );

    const organizationName = computed(() =>
      organization.value
        ? organization.value.organizationTitle
        : null,
    );

    const isOrganizationAdmin = computed(() =>
      organization.value ? organization.value.isAdmin : false,
    );

    return {
      organization,
      organizationUrl,
      organizationName,
      isOrganizationAdmin,
      setOrganization,
      reset,
    };
  },
);
